/* eslint-disable */
export default {
  createLog: 'Luo loki',
  creating: 'Luodaan',
  save: 'Tallenna',
  saving: 'Tallennetaan',
  saved: 'Tallennettu',
  view: 'Näytä',
  creatingFailed: 'Luominen epäonnistui.',
  savingFailed: 'Tallennus epäonnistui.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
